import { gql } from '@apollo/client';
import { BlazeError } from '@blaze-cms/core-errors';
import getDataProperties from '../../../../helpers/mappers/get-data-properties';

const buildEntityQuery = (schema, id) => {
  const { id: schemaId } = schema;
  const dataProperties = getDataProperties(schema);

  return `${schemaId}Data: ${schema.actions.get}(
    id: "${id}"
  ){
    id,
    ${dataProperties.join(',\n')}
  }`;
};

function buildDataQuery(entitySchema, id, queryProps, additionalProps, throwError = true) {
  const hasMultipleQuerys = Array.isArray(entitySchema);
  const schemaToCheck = hasMultipleQuerys ? entitySchema[0] : entitySchema;
  if (
    !schemaToCheck ||
    !schemaToCheck.actions ||
    !schemaToCheck.actions.get ||
    !schemaToCheck.properties
  ) {
    if (throwError) {
      throw new BlazeError(
        'DataEntity query requires get action and properties from entity schema'
      );
    }

    return gql`
      query {
        __typename
      }
    `;
  }

  const dataProperties = queryProps || getDataProperties(schemaToCheck, additionalProps);

  if (!hasMultipleQuerys)
    return gql`query {
    entityData: ${entitySchema.actions.get}(
        id: "${id}"
      ){
        id,
        ${dataProperties.join(',\n')}
      }
    }`;
  return gql`query {
      ${entitySchema.map(schema => buildEntityQuery(schema, id)).join('')}
      }`;
}

export default buildDataQuery;
